module.exports = __webpack_public_path__ + "static/media/43@2x.a84573a4.png";